import React from 'react';

const formatDate = (dateString) => {
  if (!dateString) return '--';
  try {
    const d = new Date(dateString);
    return d.toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch (e) {
    return 'Invalid Date';
  }
};

const getStatusBadge = (status) => {
  switch ((status || '').toString().toLowerCase()) {
    case 'active': return 'badge badge-success';
    case 'pending': return 'badge badge-warning';
    case 'inactive': return 'badge badge-secondary';
    case 'rejected': return 'badge badge-danger';
    default: return 'badge badge-light';
  }
};

const AmountCell = ({ value }) => (
  <span className="text-dark font-w600">₹{parseFloat(value || 0).toLocaleString('en-IN')}</span>
);

const StatusBadge = ({ value }) => (
  <span className={getStatusBadge(value)}>{value || '--'}</span>
);

const DateCell = ({ value }) => (
  value ? <span className="text-muted">{formatDate(value)}</span> : '--'
);

export const COLUMNS = [
  {
    Header: "#",
    accessor: "id",
    Cell: ({ row, state }) => {
      return row.index + 1 + state.pageIndex * state.pageSize;
    }
  },
  {
    Header: "Depositor Info",
    accessor: "name",
    Cell: ({ value, row }) => (
      <div className="d-flex align-items-center">
        <div className="avatar avatar-sm me-2">
          <span className="avatar-title bg-primary text-white rounded-circle">
            {value?.charAt(0)?.toUpperCase()}
          </span>
        </div>
        <div>
          <h6 className="mb-0 text-dark">{value}</h6>
          <small className="text-muted">{row.original.depositorCode}</small>
        </div>
      </div>
    )
  },
  {
    Header: "Contact Info",
    accessor: "phoneNo",
    Cell: ({ value, row }) => (
      <div>
        {value && <div className="text-dark">{value}</div>}
        {row.original.email && <small className="d-block text-muted">{row.original.email}</small>}
      </div>
    )
  },
  {
    Header: "Location",
    accessor: "city",
    Cell: ({ value, row }) => (
      <div className="text-dark">
        {row.original.city && <div>{row.original.city}</div>}
        {row.original.district && <span><small className="text-muted">{row.original.district}</small></span>}
        {row.original.state && <small className="d-block text-muted">{row.original.state}</small>}
        {!row.original.city && !row.original.district && !row.original.state && '--'}
      </div>
    )
  },
  {
    Header: "Company",
    accessor: "companyName",
    Cell: ({ value }) => (
      <span className="text-dark">{value || '--'}</span>
    )
  },
  {
    Header: "Deposits Info",
    accessor: "totalDeposits",
    Cell: ({ value, row }) => (
      <div>
        <div className="text-dark font-w600">
          {value || 0} Deposits
        </div>
        {row.original.totalAmount && parseFloat(row.original.totalAmount) > 0 && (
          <small className="text-success">
            ₹{parseFloat(row.original.totalAmount).toLocaleString('en-IN')}
          </small>
        )}
      </div>
    )
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: ({ value, row }) => (
      <>
      <div>
        <span className={getStatusBadge(value)}>{value || '--'}</span>
      </div>
      <div>
        {row.original.isPartner && (
          <span className="badge badge-info badge-xs">Partner</span>
        )}
      </div>
      </>
    )
  },
  {
    Header: "Created Date",
    accessor: "createdAt",
    Cell: DateCell
  },
  {
    Header: "Action",
    accessor: "actions",
    Cell: ({ row }) => row.original // This will be handled in the parent component
  }
];